import {TopScorerContainer, TopScorerImg, TopScorerSubtext, TopScorerText} from "./TopScorer.styles";
import React from "react";
import PropTypes from 'prop-types';

const TopScorer = ({info}) => {
    return (<TopScorerContainer>
        <TopScorerImg src={'/top-scorer.png'}/>
        <TopScorerText>{info?.name + ' ' + info?.surname}</TopScorerText>
        <TopScorerSubtext>{info?.goals + ' goli'}</TopScorerSubtext>
    </TopScorerContainer>)
};

TopScorer.propTypes = {
    info: PropTypes.shape({name: PropTypes.string, surname: PropTypes.string, goals: PropTypes.number}).isRequired
}

TopScorer.defaultProps = {
    info: {name: 'Król', surname: 'strzelców', goals: 0}
}

export default TopScorer;
